<template>
  <div class="search-container">
    <a-input-search
      class="select-container"
      placeholder="请输入调研模板名称"
      style="width:200px;"
      @search="value => $emit('onSearch', value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入用户"
      style="width:150px;"
      @search="value => $emit('onSearchUser', value)"
    />
    <a-select
      style="width:200px"
      class="select-container"
      placeholder="请选择企业"
      show-search
      :filter-option="filterOption"
      @change="value => $emit('onSearchCompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>时间：
    <a-date-picker @change="value=>$emit('onStartTime',value)" />
    <a-date-picker
      class="select-container"
      @change="value=>$emit('onEndTime',value)"
    />

    <a-button
      type="primary"
      shape="round"
      icon="download"
      @click="$emit('onExport')"
    >
      导出
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyData: [{id: 0, name: '所有公司'}],
    };
  },
  mounted() {
    // 获取药企
    this.getCompanyData();
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 获取企业
    async getCompanyData() {
      let result = await this.$http.post('/company/getCompanyList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return {
            name: item.team_name
              ? item.team_name
              : item.companyInfo.qichacha_name,
            ...item,
          };
        });
        this.companyData = [...this.companyData, ...data];
      }
    },
  },
};
</script>
<style lang="scss">
.search-container {
  min-height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-select-selection{
    border-radius: 15px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
  .select-container {
    margin-right: 10px;
  }
}
</style>
